// Shadow mode is dogfooded on our own support workspace before it opens to everyone.
export const SHADOW_MODE_WORKSPACE_IDS: readonly string[] = [
	"922eb553-8dc5-4a00-a16b-01735334be53",
	"56cdb889-ab63-4c28-8c8a-a5fb85a4212e",
	"0672161f-7efe-4e88-998c-3ab19a1d42d9",
	"0e05ccb2-f2eb-40d5-80c6-4056d7ff9be8",
	"21a37c2a-adb9-4024-b46a-e7d2eabe9db7",
]

// Local development opens it to every workspace, so seeded demos keep working.
export function isShadowModeAvailable(
	workspaceId: string | null | undefined,
	{ isDevelopment = false }: { isDevelopment?: boolean } = {},
): boolean {
	if (isDevelopment) return true
	return !!workspaceId && SHADOW_MODE_WORKSPACE_IDS.includes(workspaceId)
}
